import { styled } from "@mui/material";
import { Colors } from "../theme";

export const CourseViewContainer = styled("div")({
  padding: "0 20px",
  "& .infinite-scroll-component ": {
    overflow: "hidden !important",
  },
  "@media (max-width: 900px)": {
    padding: "10px",
  },
  ".search-courses": {
    display: "flex",
    alignItems: "center",
    marginBottom: "20px",
    width: "fit-content",
    borderRadius: "4px",
    fontSize: "12px",
    border: `1px solid ${Colors.border}`,

    "& input": {
      width: "300px",
      padding: "10px",
      outline: "none",
      border: "none",
      borderRadius: "4px",
      "@media (max-width: 900px)": {
        width: "100%",
      },
      "&::placeholder": {
        color: Colors.garyText,
      },
      "&:focus": {
        borderColor: Colors.primary,
      },
    },
    "& .search-icon": {
      marginLeft: "10px",
      cursor: "pointer",
    },
    "@media (max-width: 900px)": {
      width: "100%",
    },
  },
  "&.scroll-container ": {
    height: "80vh",
    overflowY: "auto",
    padding: "20px 0",
  },
  ".course-grid": {
    padding: " 10px 0",
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "20px",

    "@media (max-width: 1200px)": {
      gridTemplateColumns: "repeat(3, 1fr)",
    },
    "@media (max-width: 900px)": {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
    "@media (max-width: 500px)": {
      gridTemplateColumns: "repeat(1, 1fr)",
    },
  },
  ".loading-indicator": {
    textAlign: "center",
    padding: "20px",
    color: Colors.garyText,
  },
  ".notfound-message": {
    textAlign: "center",
    padding: "20px",
    color: Colors.garyText,
    fontStyle: "italic",
  },
});
